export const Spacer = () => {
    return <div className="h-64 bg-[#040F0F]"></div>;
  };